import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";

import {
  buildLocalizedAlternateUrls,
  resolveCurrentPathLocale,
  resolveLocalizedCanonicalUrl,
} from '@/utils/localePublicUrl';

import { buildProfileSeoMetadata } from "./profileSeo.utils";

const MetaDescriptionUsers = ({ fetchData, internal = false }) => {
  const location = useLocation();
  const metadata = buildProfileSeoMetadata(fetchData, {
    internal,
    pathname: location.pathname,
  });
  const resolvedLocale = resolveCurrentPathLocale();
  const resolvedCanonicalUrl = resolveLocalizedCanonicalUrl({ canonicalUrl: metadata.canonicalUrl, locale: resolvedLocale });
  const alternateUrls = buildLocalizedAlternateUrls({ canonicalUrl: metadata.canonicalUrl, locale: resolvedLocale });

  return (
    <>
      <Helmet>
        <html lang={resolvedLocale} />
        <title>{metadata.title}</title>
        <meta name="description" content={metadata.description} />
        <meta name="robots" content={metadata.robots} />
        <meta name="googlebot" content={metadata.robots} />
        <link rel="canonical" href={resolvedCanonicalUrl} />
        {alternateUrls.map((alternate) => (
          <link key={alternate.hrefLang} rel="alternate" hrefLang={alternate.hrefLang} href={alternate.href} />
        ))}
        <meta property="og:site_name" content="Suarte" />
        <meta property="og:type" content="profile" />
        <meta property="og:title" content={metadata.title} />
        <meta property="og:description" content={metadata.description} />
        <meta property="og:url" content={resolvedCanonicalUrl} />
        <meta property="og:image" content={metadata.image} />
        <meta property="og:image:alt" content={metadata.title} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={metadata.title} />
        <meta name="twitter:description" content={metadata.description} />
        <meta name="twitter:image" content={metadata.image} />
        <script type="application/ld+json">
          {JSON.stringify(metadata.schema)}
        </script>
      </Helmet>
    </>
  );
};

export default MetaDescriptionUsers;
